import { useTreatment } from '~/domains/common/hooks/useTreatment';
import { FEATURE } from '~/common/enums/feature.enum';

import type { PusherEnabledState } from '../types/pusher.types';

// Mixpanel Dynamic Config values must be objects, so the endpoint allowlist is wrapped:
// `{ "endpoints": ["/search", ...] }`.
type PusherEndpointsConfig = { endpoints?: unknown };

export const usePusherEnabledForEndpoint = (endpoint: string): PusherEnabledState => {
  const { isSettled, treatment } = useTreatment(FEATURE.CONFIG_PUSHER_ENABLED_ENDPOINTS);

  if (!isSettled) {
    return 'loading';
  }

  if (treatment?.treatment !== 'on') {
    return 'off';
  }

  const enabledEndpoints = (treatment.config as PusherEndpointsConfig | undefined)?.endpoints;

  if (!Array.isArray(enabledEndpoints)) {
    return 'off';
  }

  return enabledEndpoints.includes(endpoint) ? 'on' : 'off';
};
